export default __webpack_public_path__ + "static/media/PropertyDev_BG-01.eeb9632f.png";